import React, { useCallback } from 'react'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import SaudiArabiaEthnicityFields from './SaudiArabiaEthnicityFields'
import RegularEthnicityFields from './RegularEthnicityFields'
import ErrorMessage from '../../../../../../../../../../components/Form/ErrorMessage'

import { COUNTRY_ID } from '../../../../../../fields'
import { ETHNICITY_PERCENTAGE, STAKEHOLDERS_LIST } from '../../../../../../stakeholdersFields'

const EthnicityFields = ({ formik, index }) => {
  const { values, errors, touched } = formik

  const country = values[COUNTRY_ID]

  const ethnicityPath = `${STAKEHOLDERS_LIST}[${index}][${ETHNICITY_PERCENTAGE}]`

  const error = getIn(errors, ethnicityPath)
  const ethnicityTouched = getIn(touched, ethnicityPath)

  const renderEthnicityFields = useCallback(() => {
    if (country === 'SAU') {
      return <SaudiArabiaEthnicityFields formik={formik} index={index} />
    } else {
      return <RegularEthnicityFields formik={formik} index={index} />
    }
  }, [country, formik, index])

  return (
    <>
      {renderEthnicityFields()}
      {error && ethnicityTouched && <ErrorMessage error={error} />}
    </>
  )
}

EthnicityFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default EthnicityFields
